/* Direct-access stories. The links remain usable if dialogs or JS are unavailable. */
(() => {
  function init(root = document) {
    root.querySelectorAll('[data-clip-stories]').forEach(section => {
      if (section.dataset.storiesReady) return;
      const dialog = section.querySelector('[data-clip-dialog]');
      if (!dialog?.showModal) return;
      section.dataset.storiesReady = 'true';
      const media = dialog.querySelector('[data-clip-media]');
      const heading = dialog.querySelector('[data-clip-heading]');
      const shop = dialog.querySelector('[data-clip-shop]');
      let opener, closeTimer, locked = false, closing = false;
      const stop = () => {
        media.querySelectorAll('[data-social-video]').forEach(video => video.dispatchEvent(new Event('social-video:dispose')));
        media.querySelectorAll('video').forEach(video => video.pause());
        media.replaceChildren(); // Unload third-party players as well as native video.
      };
      const finish = () => {
        clearTimeout(closeTimer);
        stop();
        dialog.close();
        dialog.classList.remove('is-closing');
        closing = false;
        if (locked) { unlockBodyScroll(); locked = false; }
        if (opener?.isConnected) opener.focus({ preventScroll: true });
      };
      const close = () => {
        if (!dialog.open || closing) return;
        closing = true;
        stop();
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
        else { dialog.classList.add('is-closing'); closeTimer = setTimeout(finish, 180); }
      };
      section.addEventListener('click', event => {
        const link = event.target.closest('[data-clip-open]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
        const template = document.getElementById(link.dataset.clipOpen);
        if (!template || dialog.open) return;
        event.preventDefault();
        opener = link;
        media.replaceChildren(template.content.cloneNode(true));
        heading.textContent = link.dataset.clipTitle;
        shop.replaceChildren(...[...link.closest('.clip-story').querySelectorAll('.clip-story-caption a')].map(a => a.cloneNode(true)));
        dialog.showModal();
        lockBodyScroll(); locked = true;
        media.querySelector('[data-play-video]')?.click();
        media.querySelector('video')?.play()?.catch(() => {});
      });
      dialog.querySelector('[data-clip-close]').addEventListener('click', close);
      dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
      dialog.addEventListener('click', event => { if (event.target === dialog) close(); });
      // Theme-editor removal must not strand a scroll lock or a loading player.
      section.closest('.shopify-section')?.addEventListener('shopify:section:unload', finish);
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden || !dialog.open) return;
        media.querySelectorAll('video').forEach(video => video.pause());
        media.querySelectorAll('[data-social-video]').forEach(video => video.dispatchEvent(new Event('social-video:pause')));
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
